import { RootState } from "../../../reducers";
import { NutrientOverride } from "../../../../data/models/documentProperties/nutrientOverride";

export const NutrientOverridesSelector = (
  state: RootState
): NutrientOverride[] => state.currentDocument.document.nutrientOverrides;
